import { render, staticRenderFns } from "./SubirBoletas.vue?vue&type=template&id=49ba9ad5&scoped=true&"
import script from "./SubirBoletas.vue?vue&type=script&lang=js&"
export * from "./SubirBoletas.vue?vue&type=script&lang=js&"
import style0 from "./SubirBoletas.vue?vue&type=style&index=0&id=49ba9ad5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ba9ad5",
  null
  
)

export default component.exports